import postcodeRepository from "./entity/postcodeRepository";

const repositories = {
  postcode: postcodeRepository,
};

export const PostcodeApiFactory = {
  get: name => repositories[name]
};
